/* Reopen Shopify's native consent dialog; never grant consent on the visitor's behalf. */
document.addEventListener('click', async function (event) {
  var button = event.target.closest('[data-ax-cookie-preferences]');
  if (!button || button.disabled) return;
  var status = button.parentElement.querySelector('[data-ax-cookie-status]');
  button.disabled = true;
  if (status) status.textContent = '';
  try {
    var started = Date.now();
    while (!(window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function')) {
      if (Date.now() - started >= 5000) throw new Error('Consent dialog unavailable');
      await new Promise(function (resolve) { setTimeout(resolve, 100); });
    }
    await window.privacyBanner.showPreferences();
  } catch (_) {
    if (status) status.textContent = button.getAttribute('data-error-message');
  } finally {
    button.disabled = false;
  }
});
